
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M8 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6zM8 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm.992 12.938a1 1 0 01-.869 1.116A7.006 7.006 0 001.999 23a1 1 0 01-2 0c0-4.531 3.386-8.37 7.876-8.93a1.003 1.003 0 011.116.869zm13.704 4.195l-.974-.562c.166-.497.278-1.019.278-1.572s-.111-1.075-.278-1.572l.974-.562a1 1 0 00-1-1.732l-.973.562A4.972 4.972 0 0018 12.101V11a1 1 0 00-2 0v1.101a4.983 4.983 0 00-2.723 1.594l-.973-.562a1 1 0 00-1 1.732l.974.562c-.166.497-.278 1.019-.278 1.572s.111 1.075.278 1.572l-.974.562a1 1 0 001 1.732l.973-.562A4.972 4.972 0 0016 21.897v1.101a1 1 0 002 0v-1.101a4.983 4.983 0 002.723-1.594l.973.562a.997.997 0 001.366-.366 1 1 0 00-.366-1.366zM17 19.999c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z"}})])
          )
        }
      }
    